import Home from 'components/screens/Home'
import PageNotFound from 'components/screens/PageNotFound'
import SignInSide from 'components/screens/SignInSide'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from 'types/store'

export const generalRoutes = {
  ROOT: '/',
  HOME: '/home',
}

const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const teamData = useSelector((state: RootState) => state.user.teamData)
  return teamData ? element : <Navigate to={generalRoutes.ROOT} replace />
}

export const Routing: React.FC = () => {
  return (
    <Routes>
      <Route path={generalRoutes.ROOT} element={<SignInSide />} />
      <Route path={generalRoutes.HOME} element={<ProtectedRoute element={<Home />} />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  )
}
